import { EARN_REWARD_OPTION } from '../../constants/pointsExchange'
import { deepMerge } from '../../util/object.helpers'
import defaultConfig from '../common/customConfig'

const customConfig = {
  howManyPointsYouEarnLabel: 'brand:reward.how-many-points-you-earn',
  buyPointsDesc: 'brand:reward.buy-points-desc',
  rewardOptionsOrder: [
    EARN_REWARD_OPTION.CASHBACK,
    EARN_REWARD_OPTION.BUY_POINTS
  ],
  howToEarnLabel: 'brand:how-to.what-are-vir'
}

export default deepMerge(defaultConfig, customConfig)
